import { TextArea, Toggle } from "@its-engineering-and-development/ui-foundation/components";
import type { PolicyFieldRequirement } from "@app/types/policy";
import { PolicyFieldBadge } from "./policy-field-badge";

const DESCRIPTION_PLACEHOLDER = "Add a description which will be displayed as an info hover to assist the submitter.";

export interface PolicyDataFieldProps {
    label: string;
    fieldType?: string;
    requirement?: PolicyFieldRequirement;
    enabled: boolean;
    onEnabledChange: (enabled: boolean) => void;
    description?: string;
    onDescriptionChange?: (description: string) => void;
    showDescription?: boolean;
    isDisabled?: boolean;
    showMetadata?: boolean;
    hint?: React.ReactNode;
}

export function PolicyDataField({
    label,
    fieldType,
    requirement,
    enabled,
    onEnabledChange,
    description = "",
    onDescriptionChange,
    showDescription = false,
    isDisabled = false,
    showMetadata = true,
    hint,
}: PolicyDataFieldProps) {
    return (
        <div className={`flex flex-col gap-4 ${isDisabled ? "opacity-60" : ""}`}>
            <div className="flex items-center justify-between gap-6">
                <div className="min-w-0 flex-1">
                    <p className={`text-sm font-semibold ${isDisabled ? "text-gray-400" : "text-gray-900"}`}>{label}</p>
                    {hint ? <div className="mt-1 text-xs text-gray-500">{hint}</div> : null}
                    {showMetadata && fieldType && requirement ? (
                        <div className="mt-1 flex flex-wrap items-center gap-2">
                            <span className={`text-xs ${isDisabled ? "text-gray-400" : "text-gray-500"}`}>{fieldType}</span>
                            <PolicyFieldBadge requirement={requirement} />
                        </div>
                    ) : null}
                </div>
                <Toggle aria-label={label} isSelected={enabled} onChange={onEnabledChange} isDisabled={isDisabled} size="md" />
            </div>
            {showDescription ? (
                <TextArea
                    aria-label={`${label} description`}
                    placeholder={DESCRIPTION_PLACEHOLDER}
                    value={description}
                    onChange={onDescriptionChange ?? (() => undefined)}
                    rows={4}
                    isDisabled={isDisabled}
                    textAreaClassName="min-h-[104px] resize-none"
                />
            ) : null}
        </div>
    );
}
